import { Component } from '@angular/core';
import { detectBody } from '../../../app.helpers';

declare var jQuery:any;

@Component({
  selector: 'manager',
  templateUrl: 'managerLayout.template.html',
  host: {
    '(window:resize)': 'onResize()'
  }
})
export class ManagerLayoutComponent {

  public ngOnInit():any {
    detectBody();
  }

  public onResize(){
    detectBody();
  }

}
